var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.6668 32.5V45.8333C58.6668 53.8333 53.3335 59.1667 45.3335 59.1667H18.6668C10.6668 59.1667 5.3335 53.8333 5.3335 45.8333V32.5C5.3335 25.2467 9.70683 20.18 16.5068 19.3266C17.2002 19.22 17.9202 19.1667 18.6668 19.1667H45.3335C46.0268 19.1667 46.6935 19.1933 47.3335 19.3C54.2135 20.1 58.6668 25.1933 58.6668 32.5Z",
    fill: "#7E54C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3335 19.3C46.6935 19.1933 46.0268 19.1667 45.3335 19.1667H18.6668C17.9202 19.1667 17.2002 19.22 16.5068 19.3267C16.8802 18.58 17.4135 17.8867 18.0535 17.2467L26.7202 8.55334C30.3735 4.92668 36.2935 4.92668 39.9468 8.55334L44.6135 13.2734C46.3202 14.9534 47.2268 17.0867 47.3335 19.3Z",
    fill: "#7E54C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6668 33.8333H50.6668C47.7335 33.8333 45.3335 36.2333 45.3335 39.1667C45.3335 42.1 47.7335 44.5 50.6668 44.5H58.6668",
    fill: "#7E54C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDashboard);
export default __webpack_public_path__ + "static/media/wallet-dashboard.c7e98c4d2180925acf9ca3b7dd5c64ab.svg";
export { ForwardRef as ReactComponent };